module.exports = __webpack_public_path__ + "static/img/14.f26a651.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/14.png
// module id = xuGJ
// module chunks = 0